// SAVE CART

async function saveCart() {
  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    // guardamos solo lo importante
    const simplifiedCart = cart.items.map(item => ({
      variant_id: item.variant_id,
      quantity: item.quantity
    }));

    localStorage.setItem(
      'alameda_saved_cart',
      JSON.stringify(simplifiedCart)
    );

    console.log('Cart saved');
  } catch (error) {
    console.error('Error saving cart:', error);
  }
}

// RESTORE CART

async function restoreCart() {
  try {
    const savedCart = JSON.parse(
      localStorage.getItem('alameda_saved_cart')
    );

    if (!savedCart || savedCart.length === 0) return;

    // comprobar si carrito actual ya tiene cosas
    const currentCart = await fetch('/cart.js').then(res => res.json());

    if (currentCart.item_count > 0) return;

    // restaurar productos
    for (const item of savedCart) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.variant_id,
          quantity: item.quantity
        })
      });
    }

    console.log('Cart restored');

    // refrescar carrito
    window.location.reload();

  } catch (error) {
    console.error('Error restoring cart:', error);
  }
}

// SAVE cuando cambia carrito

document.addEventListener('click', function(e) {

  const addToCartButton = e.target.closest(
    'button[name="add"], .add-to-cart'
  );

  if (addToCartButton) {
    setTimeout(saveCart, 1000);
  }
});

// RESTORE al entrar

window.addEventListener('load', () => {
  restoreCart();
});